import { render, staticRenderFns } from "./Anarchive.vue?vue&type=template&id=20bc2b45&scoped=true&"
import script from "./Anarchive.vue?vue&type=script&lang=js&"
export * from "./Anarchive.vue?vue&type=script&lang=js&"
import style0 from "./Anarchive.vue?vue&type=style&index=0&id=20bc2b45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bc2b45",
  null
  
)

export default component.exports